<template>
  <div>
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      id="modalentradas"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg modal-centered" role="document">
        <div
          class="modal-content text-center"
          style="max-width: 75%"
        >
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <span class="close-label">Cancelar</span>
            <span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding">
            <div class="onboarding-content with-gradient">
              <h3 class="text-success font-weight-bold">
                AGREGAR FACTURA POR SERVICIO &nbsp;&nbsp;
                <i class="fas fa-folder-open fa-2x"></i>
              </h3>
              <hr />
              <div class="col-12">
                <div class="row">
                  <div class="col-4 text-left text-dark">
                    <label>Serie Factura</label>
                    <input
                      placeholder="Serie Factura"
                      v-model="current.serie"
                      class="form-control"
                      type="text"
                    />
                    <small
                      class="text-danger"
                      v-if="current.errors && current.errors.serie"
                      >{{ current.errors.serie[0] }}</small
                    >
                  </div>
                  <div class="col-4 text-left text-dark">
                    <label>Documento</label>
                    <input
                      class="form-control"
                      placeholder="# Documento"
                      type="text"
                      v-model="current.documento"
                    />
                    <small
                      class="text-danger"
                      v-if="current.errors && current.errors.documento"
                      >{{ current.errors.documento[0] }}</small
                    >
                  </div>
                  <div class="col-4 text-left text-dark">
                    <label>Fecha de Documento</label>
                    <input
                      v-model="current.fecha_documento"
                      class="form-control"
                      type="date"
                    />
                    <small
                      class="text-danger"
                      v-if="current.errors && current.errors.fecha_documento"
                      >{{ current.errors.fecha_documento[0] }}</small
                    >
                  </div>
                  <div class="col-3 text-left text-dark">
                    <TiendaSelectComponent :current="current" />
                  </div>

                  <div class="col-3 text-left text-dark">
                    <label>Total</label>
                    <input
                      v-model="current.valor_total"
                      class="form-control"
                      type="number"
                      placeholder="Q 0.00"
                      @change="calcularImpuesto()"
                    />
                    <small
                      class="text-danger"
                      v-if="current.errors && current.errors.valor_total"
                      >{{ current.errors.valor_total[0] }}</small
                    >
                  </div>
                  <div class="col-3 text-left text-dark">
                    <label>Total IVA</label>
                    <input
                      v-model="current.valor_iva"
                      class="form-control"
                      type="number"
                      placeholder="Q 0.00"
                    />
                    <small
                      class="text-danger"
                      v-if="current.errors && current.errors.valor_iva"
                      >{{ current.errors.valor_iva[0] }}</small
                    >
                  </div>
                  <div class="col-3 text-left text-dark">
                    <label>NIT</label>
                    <input
                      v-model="current.nit"
                      class="form-control"
                      type="text"
                      placeholder="cliente NIT"
                    />
                    <small
                      class="text-danger"
                      v-if="current.errors && current.errors.nit"
                      >{{ current.errors.nit[0] }}</small
                    >
                  </div>
                  <div class="col-12 text-left text-dark">
                    <label>Descripción del servicio</label>
                    <textarea
                      v-model="current.observaciones"
                      class="form-control"
                      style="font-size: 20px"
                      placeholder="Descripción del servicio"
                      rows="3"
                    ></textarea>
                    <smalls
                      class="text-danger"
                      v-if="current.errors && current.errors.observaciones"
                      >{{ current.errors.observaciones[0] }}</smalls
                    >
                  </div>
                </div>
                <br />
                <div>
                  <button
                    @click="guardar()"
                    class="btn btn-lg btn-outline-success btn-block"
                  >
                    <i class="fas fa-save"></i> Guardar Factura
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";

export default {
  props: ["current_"],
  components: {
    UsuarioEnTablaComponent,
    TiendaSelectComponent,
  },
  data() {
    return {
      current: {
        errors: [],
        valor_iva: "",
      },
      current_filter: {},
      dataTabla: [],
      mostrarRefresh: false,
      searchtext: "",
      filtro_estado: "",
      data: [],
    };
  },
  computed: {},
  mounted() {},
  methods: {
    cleanCurrentDefault() {
      let self = this;
      self.current = {
        errors: [],
        valor_iva: "",
      };
    },
    calcularImpuesto() {
      let self = this;
      DynamicService.getAction(
        "cxp",
        "cargos",
        self.current_.id,
        "calcular_iva_facturas_servicios",
        self.current
      ).then((res) => {
        self.current.valor_iva = res.data.valor_iva;
      });
    },
    guardar() {
      let self = this;
      Notifications.alert.confirm(
        "Agregar factura a cargo",
        "¿Esta seguro(a)?",
        "",
        function () {
          if (self.current.fecha_documento) {
            self.current.fecha_documento = moment(
              self.current.fecha_documento
            ).format("YYYY-MM-DD");
          }
          self.current.bien_servicio = self.current_.bien_servicio;
          DynamicService.postAction(
            "cxp",
            "cargos",
            self.current_.id,
            "agregar_modificar_factura_servicio",
            self.current
          )
            .then((res) => {
              Notifications.alert.success(
                "Generar cargo por entrada de compra",
                "Generado correctamente"
              );
              $("#modalentradas").modal("hide");
              self.$emit("refreshCargo");
              self.cleanCurrentDefault();
            })
            .catch((err) => {
              self.current.errors = err.response.data;
              if (err.response.data.detail) {
                Notifications.alert.error(
                  "Generar cargo por entrada de compra",
                  err.response.data.detail
                );
              }
            });
        }
      );
    },
    defaultData() {
      let self = this;
      self.current_filter = {};
      self.dataTabla = "";
    },
    refreshData() {
      let self = this;
      if (self.current_filter.fecha) {
        self.current_filter.fecha_documento = self.current_filter.fecha;
      }
      DynamicService.getActionList(
        "inv",
        "ent_compra",
        "entrada_pendientes_generar_cxp",
        self.current_filter
      ).then((response) => {
        self.dataTabla = response.data;
      });
    },
    rowClick(current) {
      let self = this;
      Notifications.alert.confirm(
        "Agregar factura a cargo",
        "¿Esta seguro(a)?",
        "",
        function () {
          console.log(self.cargo.id);
          DynamicService.getActionList(
            "wms",
            "recepcion",
            "generar_cargo_cxp",
            {
              id: current.entrada_por_compra_e,
              cargo: self.cargo.id,
            }
          )
            .then((res) => {
              Notifications.alert.success(
                "Generar cargo por entrada de compra",
                "Generado correctamente"
              );
              $("#modalentradas").modal("hide");
              self.$emit("refreshCargo");
            })
            .catch((err) => {
              Notifications.alert.error(
                "Generar cargo por entrada de compra",
                err.response.data.detail
              );
            });
        }
      );
    },
  },
};
</script>
